export const isPositiveFinancialBalance = (balance: number) => balance >= 0;
